import { createApi } from '../createApi';
import * as dummy from '../dummy/payments';
import * as real from '../api/payments';

const api = createApi(dummy, real);

/** 결제 서비스 — API_DOCS: 4. 결제 / 29. 관리자 - 거래/매출 */
export const paymentService = {
  /* 서비스 (유저용) */
  prepare: api.preparePayment,
  confirm: api.confirmPayment,
  getCards: api.getCards,
  registerCard: api.registerCard,
  deleteCard: api.deleteCard,
  getById: api.getPaymentById,
  refund: api.refundPayment,
  getReceipt: api.getReceipt,
  sendReceiptEmail: api.sendReceiptEmail,

  /* 관리자 */
  adminGetTransactions: api.getAdminTransactions,
  adminGetSummary: api.getAdminTransactionSummary,
  adminExport: api.exportAdminTransactions,
  adminGetById: api.getAdminTransactionById,
  adminRefund: api.adminRefund,
};
